import { useWarrantyClaimContext } from '@components';
import {
  FormControl,
  FormControlLabel,
  InputLabel,
  Radio,
  RadioGroup,
  useTheme,
} from '@mui/material';

import { WarrantyClaimType } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { useAuth } from '@hooks';
import { t } from '@translations';
import { Controller } from 'react-hook-form';

export const WarrantyClaimTypeFields = () => {
  const { form } = useWarrantyClaimContext();
  const {
    control,
    formState: { errors },
  } = form;
  const isError = !!errors.claimType;
  const theme = useTheme();
  const { isBeremaUser } = useAuth();

  const getClaimTypes = () => {
    const baseTypes = [
      { value: WarrantyClaimType.Warranty, label: t(TextCodes.Warranty.Block.Warranty) },
      { value: WarrantyClaimType.Complaint, label: t(TextCodes.Warranty.Block.Complaint) },
      { value: WarrantyClaimType.Goodwill, label: t(TextCodes.Warranty.Block.Goodwill) },
    ];

    return baseTypes;
  };

  const claimTypes = getClaimTypes();
  return isBeremaUser ? (
    <Controller
      control={control}
      rules={{ required: true }}
      name='claimType'
      render={({ field }) => (
        <FormControl sx={{ mt: 5, width: '100%' }} error={isError}>
          <InputLabel id='claim-type' required>
            {t(TextCodes.Warranty.Block.ClaimType)}
          </InputLabel>
          <RadioGroup {...field}>
            {claimTypes.map(({ value, label }) => (
              <FormControlLabel
                key={value}
                value={value}
                control={<Radio sx={isError ? { color: theme.palette.error.main } : {}} />}
                label={label}
                sx={{
                  width: 'fit-content',
                }}
              />
            ))}
          </RadioGroup>
        </FormControl>
      )}
    />
  ) : null;
};
